import React from "react";

function Education() {
  return (
    <div id='education' className="container">
      {/* <h4>
        Resum<span>e</span>
      </h4> */}
      <h5>Education</h5>
      <div className="career">
        <div className="comp">
          <img
            className="logo"
            src="https://www.kcau.ac.ke/wp-content/uploads/2022/06/KCAU-logo.svg"
            width={90}
            alt=""
          />
          <h5>
            Bachelor of Science - <span>Software Developement</span>
          </h5>
        </div>
        <div className="loc">
          <p>
            Ruaraka, <span>Nairobi,Kenya</span>{" "}
          </p>
          <p>
            {/* <li> */}
            Sept, 2018 - <span>Oct, 2022</span> {/* </li> */}
          </p>
        </div>
        <p className="desc">
          | Software Enginnering|Data Structure and Algorithms | Web Design| Web
          Development | Mobile Programming | Data Science | Machine Learning|
          Artificial Intelligence | ICT Project Management|Cloud Computing|
          Object Oriented Programming|Database Management|Installation and
          Customization| Awaiting Graduation on 2nd December
        </p>
      </div>
      <div className="career">
        <div className="comp">
          <img
            className="logo"
            src="https://ckti.ac.ke/wp-content/uploads/2022/04/Logo2-MAIN.png"
            width={90}
            alt=""
          />
          <h5>
            Christ The King Training Institute-{" "}
            <span>Certificate in Information Technology</span>
          </h5>
        </div>
        <div className="loc">
          <p>
            Nakuru, <span>Nakuru,Kenya</span>{" "}
          </p>
          <p>
            Feb, 2018 - <span>May,2018</span>
          </p>
        </div>
        <p className="desc">
          Computer Packages | Internet and Emails Windows Operating System| I
          attained a distinction.
        </p>
      </div>
    </div>
  );
}

export default Education;
